/* eslint-disable */
// @ts-nocheck
/**
 * RTM Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export const AlertingMetricValueType = {
  Percentage: 'PERCENTAGE',
  Duration: 'DURATION',
  Count: 'COUNT',
} as const

export type AlertingMetricValueType =
  (typeof AlertingMetricValueType)[keyof typeof AlertingMetricValueType]
